<template>
  <div id="paperHeader" class="headroot">
    <div class="headertitle">
      <h1>{{ perperName }}</h1>
    </div>
    <div class="headerspan">
      <div class="headercell">
        <span class="cellspan">学校</span>
        <span class="cellcontent">{{ college }}</span>
      </div>
      <div class="headercell">
        <span class="cellspan">专业</span>
        <span class="cellcontent">{{ marjor }}</span>
      </div>
      <div class="headercell">
        <span class="cellspan">班级</span>
        <span class="cellcontent">{{ className }}</span>
      </div>
      <div class="headercell">
        <span class="cellspan">姓名</span>
        <span class="cellcontent">{{ studentName }}</span>
      </div>
      <div class="headercell">
        <span class="cellspan">学号</span>
        <span class="cellcontent">{{ studentNumber }}</span>
      </div>
    </div>
    <div class="score-table-wrapper">
      <table border="1" cellspacing="0" cellpadding="0" class="headertab">
        <tr>
          <th class="tablespan" v-for="(k, index) in questionMark" :key="index">
            {{ k.qtitle }}
          </th>
        </tr>
        <tr>
          <th
            class="tablecontent"
            v-for="(k, index) in questionMark"
            :key="index"
          >
            {{ k.qscore }}
          </th>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "paperHeader",
  props: {
    perperName: String,
    college: {
      type: String,
      default: ""
    },
    marjor: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    studentName: {
      type: String,
      default: ""
    },
    studentNumber: {
      type: String,
      default: ""
    },
    questionMark: {
      type: Array,
      default: () => [
        {
          qtitle: "单选题",
          qscore: ""
        },
        {
          qtitle: "多选题",
          qscore: ""
        },
        {
          qtitle: "判断题",
          qscore: ""
        },
        {
          qtitle: "总分",
          qscore: ""
        }
      ]
    }
  }
};
</script>
<style scoped lang="scss">
.headroot {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  width: 100%;
  box-sizing: border-box;

  .headertitle {
    width: 100%;
    margin-bottom: 40px;
    text-align: center;

    h1 {
      font-size: 24px;
      font-weight: 700;
      color: #000;
      margin: 0;
      font-family: "SimHei", "Heiti SC", sans-serif; // Make it look like a title
    }
  }

  .headerspan {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 30px;
    padding: 0 20px;
    box-sizing: border-box;

    .headercell {
      display: flex;
      align-items: flex-end;

      .cellspan {
        font-weight: 700;
        font-size: 15px;
        color: #000;
        margin-right: 8px;
        white-space: nowrap;
        font-family: "SimHei", sans-serif;
      }

      .cellcontent {
        display: inline-block;
        min-width: 80px;
        padding: 0 10px 2px;
        border-bottom: 1px solid #000;
        text-align: center;
        font-size: 15px;
        color: #333;
        line-height: 1.2;
      }
    }
  }

  .score-table-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-start; // Align table to left as per image? Or maybe just padding
    padding-left: 20px;
  }

  .headertab {
    border-collapse: collapse;
    border: 1px solid #000;
    margin-top: 10px;
    background: transparent;

    th {
      border: 1px solid #000;
      padding: 8px 0;
      font-size: 14px;
      font-weight: 700;
      color: #000;
      min-width: 80px;
      text-align: center;
      font-family: "SimHei", sans-serif;
    }

    .tablecontent {
      font-weight: 500;
      font-family: "SimSun", serif;
    }
  }
}
</style>
